import { render, staticRenderFns } from "./CardPillarInfo.vue?vue&type=template&id=6f8fff0f&scoped=true&"
import script from "./CardPillarInfo.vue?vue&type=script&lang=js&"
export * from "./CardPillarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardPillarInfo.vue?vue&type=style&index=0&id=6f8fff0f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8fff0f",
  null
  
)

export default component.exports